import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'levering',
    [ORDER_METHODS.PICKUP]: 'afhentning',
    [ORDER_METHODS.ROOM_SERVICE]: 'på stedet',
  },
  feedback: {
    payment_method_disabled: 'Vi accepterer ikke {{paymentMethod}}-betalinger til {{orderMethod}}-ordrer',
    cash_disabled: 'Vi accepterer ikke kontant betaling til {{orderMethod}}-ordrer',
  },
};
